import React from 'react';
import { useTranslation } from 'react-i18next';
import formatPrice, { roundUpParser } from '@honda-canada/js-utilities/lib/formatPrice';
import PriceComponent from '../PriceComponent';
import { useAppSelector } from '../../core/utils';
import useDealerProvincePricing from '../../utils/hooks/useDealerProvincePricing';
import { selectPrimaryCalculatorPaymentOptions } from '../../core/reducers/financialCalculators';
const priceFormatter = (price, language) => formatPrice(price, language, 0, roundUpParser);
const priceComponentStyles = {
    priceStyles: {
        title: {
            size: 'extraSmall',
            styles: {
                whiteSpace: 'nowrap',
            },
        },
        tooltipContainer: {
            tooltip: {
                alignSelf: 'center',
                height: '22px !important',
            },
        },
        copy: {
            size: 'subheading',
            styles: {
                letterSpacing: ['sm', 'md'],
            },
        },
    },
    errorStyles: {
        container: {
            alignItems: 'start',
        },
    },
};
const VehicleCardPricing = (props) => {
    var _a, _b, _c;
    const { data, error, isFetching } = props;
    const { t } = useTranslation();
    const prices = {
        allInPrice: { value: (_a = data === null || data === void 0 ? void 0 : data.sellingPrice) === null || _a === void 0 ? void 0 : _a.value, label: t('Shared.Common.sellingPriceLabel') },
        msrpPrice: { value: (_b = data === null || data === void 0 ? void 0 : data.msrp) === null || _b === void 0 ? void 0 : _b.value, label: ((_c = data === null || data === void 0 ? void 0 : data.msrp) === null || _c === void 0 ? void 0 : _c.label) || t('Shared.Common.msrpStartingFromLabel') },
    };
    const { isSellingPriceProvince } = useDealerProvincePricing();
    const { includeFees } = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const sellingPriceTooltipLabel = includeFees
        ? t('Shared.Common.sellingPriceDisclaimerWithTaxLabel')
        : t('Shared.Common.sellingPriceDisclaimerNoTaxLabel');
    const msrpTooltipLabel = t('Shared.Common.msrpDisclaimerLabel');
    return (React.createElement(PriceComponent, { allInPriceTooltipLabel: sellingPriceTooltipLabel, errorMessage: t('Pages.Bap.apiLoadingError'), hasError: !!error, height: ['auto', 'auto', undefined], horizontalAlignment: "left", isFetching: isFetching, msrpStartingFromTooltipLabel: msrpTooltipLabel, priceComponentStyles: priceComponentStyles, prices: prices, alignItems: undefined, saveAboveLabel: undefined, suppressDiscount: undefined, showSellingPriceDisclaimer: undefined, frieghtPDIFeesCost: undefined, isLoadingIconLarge: true, errorIconName: "exclamationAlert", priceFormatter: priceFormatter, overrideShowSellingPrice: isSellingPriceProvince, loadingIconHeight: "28px", dealerFee: undefined, showRebateDisclaimerIndicator: false }));
};
export default VehicleCardPricing;
